<div class="privacy-header">
  <div class="privacy-header-title">
    <span>Datenschutz</span>
  </div>
</div>

<div class="privacy-content">
  <span [innerHtml]="privacyText"></span>
</div>